<template>
    <input ref="input" type="text" />
</template>

<script>
import Cleave from 'cleave.js';
import _ from 'lodash';
import 'cleave.js/dist/addons/cleave-phone.us';

export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        events: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            cleave: null,
        };
    },
    watch: {
        options: {
            deep: true,
            handler(val) {
                this.cleave.destroy();
                this.cleave = new Cleave(this.$el, val);
            },
        },
    },
    mounted() {
        this.$el.value = this.value;
        this.cleave = new Cleave(this.$el, this.options);
        _.forEach(_.keys(this.events), (key) => {
            this.$refs.input.addEventListener(key, this.events[key]);
        });
        if (this.options.maxLength) {
            this.$el.setAttribute('maxlength', this.options.maxLength);
        }
        // in case of cleave.js remove result or properties from cleave instance.
        if (
            this.cleave.properties &&
            Object.prototype.hasOwnProperty.call(this.cleave.properties, 'result')
        ) {
            this.$watch('cleave.properties.result', this.emitEvent);
        } else {
            this.$el.addEventListener('input', this.emitEvent);
        }
    },
    beforeDestroy() {
        this.cleave.destroy();
    },
    methods: {
        emitEvent() {
            this.$emit('input', this.$el.value);
            this.$emit('rawValueChanged', this.cleave.getRawValue());
        },
    },
};
</script>
